import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Avatar,
  Box,
  alpha,
  Stack,
  lighten,
  Divider,
  IconButton,
  Tooltip,
  Typography,
  styled,
  useTheme
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { SidebarContext } from 'src/contexts/SidebarContext';
import { useAuth } from 'src/contexts/AuthContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';

import HeaderButtons from './Buttons';
import HeaderUserbox from './Userbox';
import HeaderMenu from './Menu';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const { user } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const nombreCompleto = user?.empresa?.nombre ?? '';
  const nombreEmpresa = nombreCompleto.replace(/^Restaurante\s+/i, '').trim() || nombreCompleto;
  const sucursalNombre = user?.sucursal?.nombre;
  const puedeCambiarSucursal = (user?.sucursales?.length ?? 0) > 1;

  const textoEmpresaSucursal = sucursalNombre
    ? `${nombreEmpresa} · ${sucursalNombre}`
    : nombreEmpresa;

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
                theme.colors.alpha.black[100],
                0.2
              )}, 0px 5px 22px -4px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}`
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }} display="flex" alignItems="center" gap={1}>
        {nombreEmpresa && (
          <Tooltip title={puedeCambiarSucursal ? 'Haz clic para cambiar sucursal' : ''}>
            <Box
              component={puedeCambiarSucursal ? 'button' : 'div'}
              onClick={puedeCambiarSucursal ? () => navigate('/seleccionar-sucursal') : undefined}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                border: 'none',
                background: 'none',
                cursor: puedeCambiarSucursal ? 'pointer' : 'default',
                padding: 0,
                '&:hover': puedeCambiarSucursal ? { opacity: 0.85 } : {}
              }}
            >
              <Avatar
                sx={{
                  width: 28,
                  height: 28,
                  bgcolor: theme.colors.primary.main,
                  color: theme.colors.alpha.white[100],
                  fontSize: 18
                }}
              >
                <RestaurantMenuIcon fontSize="inherit" />
              </Avatar>
              <Typography variant="brand" noWrap>
                {textoEmpresaSucursal}
              </Typography>
              {puedeCambiarSucursal && (
                <StorefrontIcon sx={{ fontSize: 18, opacity: 0.7 }} />
              )}
            </Box>
          </Tooltip>
        )}
        <Stack
          direction="row"
          divider={<Divider orientation="vertical" flexItem />}
          alignItems="center"
          spacing={2}
        >
          {/* <HeaderMenu /> */}
        </Stack>
      </Box>
      <Box display="flex" alignItems="center">
        {/* <HeaderButtons /> */}
        <HeaderUserbox />
        <Box
          component="span"
          sx={{
            ml: 2,
            display: { lg: 'none', xs: 'inline-block' }
          }}
        >
          <Tooltip arrow title="Toggle Menu">
            <IconButton color="primary" onClick={toggleSidebar}>
              {!sidebarToggle ? (
                <MenuTwoToneIcon fontSize="small" />
              ) : (
                <CloseTwoToneIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
